import { Component, Input, NgModule } from '@angular/core';

@Component({
  selector: 'i-tabler',
  standalone: false,
  template: '<i [class]="iconClass" aria-hidden="true"></i>'
})
export class TablerIconShimComponent {
  @Input() name = '';

  get iconClass(): string {
    const normalized = (this.name || '').trim();
    return normalized ? `ti ti-${normalized}` : 'ti';
  }
}

@NgModule({
  declarations: [TablerIconShimComponent],
  exports: [TablerIconShimComponent]
})
export class TablerIconsModule {
  static pick(_icons: Record<string, unknown>): typeof TablerIconsModule {
    return TablerIconsModule;
  }
}
